import React from 'react';
import AppShell from '@/components/layout/AppShell';
import { ownerNav } from '@/lib/navConfig';
import OutstandingPayments from '@/components/outstanding/OutstandingPayments';

export default function OwnerOutstanding() {
  return (
    <AppShell nav={ownerNav} title="Status Telat Pembayaran" showBell>
      <OutstandingPayments />
    </AppShell>
  );
}
